module.exports = __webpack_public_path__ + "static/media/fire.06ca1907.png";